import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
} from '@mui/material';
import useCurrentUser from 'src/hooks/useCurrentUser';
import EmailIcon from '@mui/icons-material/Email';
import * as dealsApi from 'src/services/APIs/dealsApi';
import { useSnackbar } from 'notistack';
import { Form, Field, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'src/redux/hooks';

type EmailInputProps = {
  email: string;
};

const EmailInput = ({ email }: EmailInputProps) => (
  <Box
    mb={2}
    sx={{
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <TextField
      InputProps={{
        startAdornment: <InputAdornment position="start">From</InputAdornment>,
      }}
      fullWidth
      variant="standard"
      value={email}
    />
  </Box>
);
const validationSchema = Yup.object().shape({
  fromEmail: Yup.string().email('Invalid email').required('From email is required'),
});

type ContactSupportProps = {
  setIsContactSupportVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

const ContactUs = ({ setIsContactSupportVisible }: ContactSupportProps) => {
  const user = useCurrentUser();
  const { client } = useSelector((state) => state.admin);
  const { enqueueSnackbar } = useSnackbar();

  const handleContactSupportPopupClose = () => {
    setIsContactSupportVisible(false);
  };

  const formik = useFormik({
    initialValues: {
      notes: '',
      fromEmail: user.emailAddress || '',
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        await dealsApi.postCustomerSupportSendEmail({
          notes: values.notes,
          fromEmail: values.fromEmail,
          businessName: client?.legalBusinessName,
        });

        enqueueSnackbar('Your support request has been sent.');
        handleContactSupportPopupClose();
      } catch (error) {
        enqueueSnackbar('Error sending support request. Please try again.', { variant: 'error' });
      }
    },
  });

  return (
    <Dialog open={true} onClose={handleContactSupportPopupClose}>
      <FormikProvider value={formik}>
        <Form>
          <DialogTitle>Contact Support</DialogTitle>
          <DialogContent>
            <Box sx={{ width: '400px' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 2,
                }}
              >
                <Box
                  mt={2}
                  sx={{
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 15,
                    height: 15,
                    border: '2px solid grey',
                    borderRadius: '50%',
                    padding: 4,
                  }}
                >
                  <EmailIcon fontSize="large" />
                </Box>
              </Box>
              <EmailInput email={user ? user.emailAddress : ''} />
              <Field
                as={TextField}
                name="notes"
                id="outlined-multiline-static"
                multiline
                rows={6}
                placeholder="Message..."
                fullWidth
                error={Boolean(formik.touched.notes && formik.errors.notes)}
                helperText={formik.touched.notes && formik.errors.notes}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => formik.handleSubmit()} variant="contained">
              SEND
            </Button>
            <Button onClick={handleContactSupportPopupClose}>Cancel</Button>
          </DialogActions>
        </Form>
      </FormikProvider>
    </Dialog>
  );
};
export default ContactUs;
